import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IMasterList } from "../../../Pages/Master/IMaster";

export const MasterSlicer = createSlice({
  name: "Master",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IMasterList[]>,
  reducers: {
    getMaster: (state, _) => {
      state.isLoading = true;
    },
    successGetMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getMaster, failureGetMaster, successGetMaster } =
  MasterSlicer.actions;

export default MasterSlicer.reducer;
